/**
 * Call this function at the end of a switch statement
 * to make use of TypeScripts exhaustiveness checks.
 *
 * At runtime this could throw an `Error` if it is actually called.
 */
export function neverReachedFor(arg: never): never {
    throw new Error(`This function should never be called. However, it was called with '${arg}'.`);
}
